import React from 'react';
import clsx from 'clsx';
import { Tooltip } from '../Tooltip/index.ts';
import styles from './LocationFlag.module.scss';
import { getCountryOrContinentImageLink, getTooltipText } from './utils.ts';
import { T } from '../T/index.ts';
import { Image } from '../Image/index.ts';
import { passThroughTranslation } from '@colonist/i18n';
export const LocationFlag = ({ className, location, tooltipPosition = 'top', onClick, isUserOnDiscord = false })=>{
    const { countryCode, continentCode } = location;
    var _ref;
    return /*#__PURE__*/ React.createElement(Tooltip, {
        delay: 0,
        centerText: true,
        position: tooltipPosition,
        content: /*#__PURE__*/ React.createElement(T, {
            id: getTooltipText(countryCode, continentCode)
        })
    }, /*#__PURE__*/ React.createElement(Image, {
        onClick: onClick,
        className: clsx(styles.flag, {
            [styles.clickable]: onClick != undefined
        }, className),
        image: {
            src: getCountryOrContinentImageLink(countryCode, continentCode, isUserOnDiscord),
            alt: passThroughTranslation((_ref = countryCode !== null && countryCode !== void 0 ? countryCode : continentCode) !== null && _ref !== void 0 ? _ref : '')
        }
    }));
};
